<script setup lang="ts">
const { company } = useCompany()
const lp = useLocalePath()
</script>

<template>
  <Container v-if="company.our_team" class="screen-content flex flex-col items-center space-y-6 px-2 pt-16">
    <div class="mb-8 flex flex-col items-center justify-center text-center">
      <Heading as="h2" size="caption" class="mb-2">{{ company.our_team.title }}</Heading>
      <Heading as="h3" size="medium" class="mb-10 flex flex-col px-10 lg:px-0">
        {{ company.our_team.headline }}
      </Heading>

      <AboutUsTeamCards />

      <Cta :href="lp('/careers')" :label="$t('company.ctaLabel')" />
    </div>
  </Container>
</template>
